import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../../partials/aside/Sidebar";
import helperSpinner from "../../../../../../helpers/spinner";
import httpService from "../../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../../helpers/numbers";
import helpersTime from "../../../../../../helpers/time";
import StatusCampaignSimple from "../../../banner/StatusCampaignSimple";
import Pagination from "../../../../../partials/content/Pagination";

export default function AllCampaign() {
  const [allCampaignBannerAlternative, setAllCampaignBannerAlternative] =
    useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [campaignIDSearchFilter, setCampaignIDSearchFilter] = useState();

  useEffect(() => {
    getAllCampaignBannerAlternative();
  }, []);

  useEffect(() => {
    getAllCampaignBannerAlternative();
  }, [currentPage, countItemPerPage, campaignIDSearchFilter]);

  const getAllCampaignBannerAlternative = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const requestGetAllCampaignBannerAlternative =
      await sendRequestGetAllCampaignBannerAlternative(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!requestGetAllCampaignBannerAlternative) {
      return;
    }

    setAllCampaignBannerAlternative(
      requestGetAllCampaignBannerAlternative.campaigns
    );
    setCountPage(requestGetAllCampaignBannerAlternative.count_page);
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (campaignIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${campaignIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const sendRequestGetAllCampaignBannerAlternative = async (
    searchFilterQuery
  ) => {
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/campaign/manage/banner/alternative/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return categoryAllPublisher.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateTagHtmlAllCampaignBannerAlternative = () => {
    return (
      <>
        <div className="alert alert-info">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره کمپین</label>
              </div>
              <div>
                <input
                  onKeyUp={(e) => setCampaignIDSearchFilter(e.target.value)}
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  id="site"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره کمپین</td>
                <td>شماره گروه نمایش دهنده</td>
                <td>اولویت کمیپن</td>
                <td>نام کمپین</td>
                <td>تاریخ درج </td>
                <td>وضعیت</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allCampaignBannerAlternative.map(
                (campaingBannerAlternative, index) => {
                  let textStateCampaign =
                    StatusCampaignSimple.statusCampaignString()[
                      campaingBannerAlternative.cam_status
                    ];

                  let tagClass;
                  switch (campaingBannerAlternative.cam_status) {
                    case StatusCampaignSimple.statusCampaign
                      .PENDING_TO_START_DATE:
                      tagClass = "warning";
                      break;
                    case StatusCampaignSimple.statusCampaign.ACTIVE:
                      tagClass = "success";
                      break;
                    case StatusCampaignSimple.statusCampaign.FINISHED:
                      tagClass = "info";
                      break;
                    case StatusCampaignSimple.statusCampaign.CANCELED:
                      tagClass = "danger";
                      break;
                  }

                  return (
                    <tr>
                      <td>{helpersNumber.toPersianNum(index + 1)}</td>
                      <td>
                        {helpersNumber.toPersianNum(
                          campaingBannerAlternative.cam_id
                        )}
                      </td>
                      <td>
                        {helpersNumber.toPersianNum(
                          campaingBannerAlternative.cam_category_id
                        )}
                      </td>
                      <td>
                        {helpersNumber.toPersianNum(
                          campaingBannerAlternative.campaign_priority
                        )}
                      </td>
                      <td>{campaingBannerAlternative.cam_name}</td>
                      <td className="number-finance">
                        {helpersNumber.toPersianNum(
                          campaingBannerAlternative.cam_created_at.split(
                            " "
                          )[1] +
                            "  " +
                            helpersTime.convertGregorianToJalali(
                              campaingBannerAlternative.cam_created_at
                            )
                        )}
                      </td>
                      <td>
                        <div className="text-center">
                          <span className={`badge badge-${tagClass} `}>
                            {textStateCampaign}
                          </span>
                        </div>
                      </td>
                      <td>
                        <span className="pl-2">
                          <Link
                            className="btn btn-info"
                            to={`/campaigns/manage/banner-alternative/info/${campaingBannerAlternative.cam_id}`}
                          >
                            <i className="fa fa-info"></i>
                          </Link>
                        </span>
                        <span>
                          <Link
                            className="btn btn-primary"
                            to={`/campaigns/manage/banner-alternative/logs-amount/${campaingBannerAlternative.cam_id}`}
                          >
                            <i className="fa fa-clipboard-list"></i>
                          </Link>
                        </span>
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
        {countPage > 1 && generatePagination()}
      </>
    );
  };

  return (
    <>
      <Sidebar
        openItem="manage-campaigns"
        activeItem="all-campaign-banner-alternative"
      />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  همه کمپین های جایگزین بنری
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="pb-3">
                <span>
                  <Link
                    className="btn btn-info"
                    to="/campaigns/manage/banner-alternative/add"
                  >
                    <span>
                      <i className="fa fa-plus"></i>
                    </span>
                    <span className="pr-2">کمپین بنری جایگزین جدید</span>
                  </Link>
                </span>
              </div>

              <div className="alert alert-info">
                <p>
                  ارزش کمپین های بنری هر روز راس ساعت ۲۳:۴۵ محاسبه و بروز میشود.
                </p>
                <p>
                  از این{" "}
                  <Link
                    target={"_blank"}
                    to="/manage/publishers/all-banner-category-site-publisher-alternative"
                  >
                    صفحه
                  </Link>{" "}
                  برای ساخت گروه نمایش دهنده بنری استفاده کنید.
                </p>
              </div>
              {allCampaignBannerAlternative.length == 0 &&
              campaignIDSearchFilter == null ? (
                <></>
              ) : (
                generateTagHtmlAllCampaignBannerAlternative()
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
